import splitioGateway from "./gateway";
var Treatment;
(function (Treatment) {
    Treatment["ON"] = "on";
    Treatment["OFF"] = "off";
    Treatment["CONTROL"] = "control";
})(Treatment || (Treatment = {}));
const NULL_GATEWAY = {
    destroy: () => Promise.resolve(),
    get: () => Treatment.CONTROL,
};
const BOOTSTRAP_DEFAULTS = {
    retries: 1,
    timeout: 1000,
};
const DEFAULT_KEY = 'localhost';
export default class Features {
    constructor(options, createGateway = splitioGateway) {
        this.gateway = NULL_GATEWAY;
        this.options = options;
        this.createGateway = createGateway;
    }
    bootstrap(bootstrapOptions) {
        const { accountId = '', key = DEFAULT_KEY, defaults = {} } = this.options;
        const { timeout, retries } = Object.assign(Object.assign({}, BOOTSTRAP_DEFAULTS), bootstrapOptions);
        const gatewayOptions = { accountId, key, defaults, timeout, retries };
        return this.createGateway(gatewayOptions)
            .then((g) => {
            this.gateway = g;
        })
            .catch((error) => {
            throw new Error(`Failed to initialize features client: ${error}`);
        });
    }
    get(feature, attributes = {}) {
        const treatment = this.gateway.get(feature, attributes);
        const { defaults = {} } = this.options;
        if (treatment === Treatment.CONTROL && feature in defaults) {
            return defaults[feature];
        }
        return treatment;
    }
    isActive(feature, attributes = {}) {
        return this.get(feature, attributes).toLowerCase() === Treatment.ON;
    }
    destroy() {
        if (!this.gateway) {
            return Promise.resolve();
        }
        return this.gateway.destroy().then(() => {
            this.gateway = NULL_GATEWAY;
        });
    }
}
